import { Dict, SfFormData } from "@/types/generalTypes";

export default function (
  formData: SfFormData,
  joinArrays = false,
  separator = ",",
) {
  const res: Dict<any> = {};
  for (const k in formData.fields) {
    if (typeof formData.fields[k].value == "string") {
      res[k] = formData.fields[k].value.trim();
    } else if (Array.isArray(formData.fields[k].value) && joinArrays) {
      res[k] = formData.fields[k].value.join(separator);
    } else {
      res[k] = formData.fields[k].value;
    }
  }
  return res;
}
